import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SelectItem } from 'primeng/api';
import { FormMode, Client } from 'src/app/_models/models';
import { AlertService, AlertOptions, AlertTypes, AlertMessage, AlertSeverity } from 'src/app/alert/alert.component';
import { ClientsService } from 'src/app/services/api/clients.service';
import { RouterOutlet } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
import { SnackbarComponent } from 'src/app/Shared Components/snackbar/snackbar.component';
//import { parse } from 'path';
//import { Console } from 'console';

@Component({
  selector: 'app-invoicing-client-index-component',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.scss']
})

export class InvoicingClientIndexComponent implements OnInit{

  @ViewChild(RouterOutlet) outlet: RouterOutlet;

  _http: HttpClient;
  _baseUrl: string;
  public formListData: any[] = [];
  public tabledata : any[] = [];
  public mode: FormMode = FormMode.None;
  public formModes = FormMode;
  public model: Client = new Client();
  public showdiag: boolean = false;
  public diagmsg: string;

  carriers: SelectItem[] = new Array<SelectItem>();

  frequency: SelectItem[] = [
    { label: "Weekly", value: 1 },
    { label: "BiWeekly", value: 2 },
    { label: "Monthly", value: 3 }
  ];

  mindate: Date = new Date(2013, 1, 1);
  maxdate: Date = new Date(2037, 12, 31);


  constructor(private clients:ClientsService, private alert: AlertService, private _snackBar: MatSnackBar) {
    //this._baseUrl = baseUrl + 'api/clients';
    //this._http = http;


    //this._http.get<Carrier[]>(baseUrl + 'api/carriers').subscribe(result => {
    //  result.forEach(e => {
    //    this.carriers.push({ label: e.Name, value: e.Id });
    //  });
    //  this.loadListData();
    //}, error => {
    //  this.alert.send(AlertMessage.getOnHttpError("ClientGetCarrierList", "Failed to carrier list", error));
    //});


      this.clients.getAll(null).subscribe(result => {
        //this.formListData = new Array<Client>();
        // result.forEach(e => {
        //  //debugger;
        //   this.formListData.push(
        //     //Id: e.Id,
        //     //Name: e.Name,
        //     //BillingID: e.BillingID,
        //     //BillingContactID: e.BillingContactID,
        //     //BillingDay: new Date(e.BillingDay),
        //     //BillingFrequency: e.BillingFrequency,
        //     //LastBilled: new Date(e.LastBilled),
        //     ////CarrierId: e.CarrierId,
        //     ////Carrier: null,
        //     //selected: false,
        //     // Id: e.Id,
        //     // Name: e.Name,
        //     // BillingID: e.BillingID,
        //     // BillingContactID: e.BillingContactID,
        //     // BillingDay: (new Date(), e?.BillingDay),
        //     // BillingFrequency: e.BillingFrequency,
        //     // LastBilled: (new Date(), e?.LastBilled),
        //     // ClientCarrierRateFiles: e.ClientCarrierRateFiles,
        //     // selected: false,

        //     JSON.parse(e)
        //   );
        //   console.log('The FormList: '+this.formListData);
        // });

        //var out = JSON.parse(result)
        this.tabledata = result;
        this.dataSource = new MatTableDataSource(result);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort
        for (var i of result) {
          this.formListData.push(i);
        }


        //console.log('The FormList: '+ JSON.parse(this.formListData[0]));

      }, error => {
        this.alert.send(AlertMessage.getOnHttpError("ClientGetListFail", "Failed to get client list", error));
      });

  }


  // displayedColumns: string[] = ['Id','Name', 'BillingID', 'BillingContactID', 'BillingDay','BillingFrequency','LastBilled','CarrierId','...'];
  displayedColumns: string[] = ['Name', 'BillingID', 'BillingContactID', 'BillingDay','BillingFrequency','LastBilled','...'];
  dataSource: MatTableDataSource<any>;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  ngAfterViewInit() {


  }
  ngOnInit() {
   // this.loadListData();


  }

  public onSubmit(form: any) {
    switch (this.mode) {
      case FormMode.Find: {
        break;
      }
      case FormMode.New: {
        if (form.invalid) {

        } else {
          this.post(form);
        }
        break;
      }
      case FormMode.Edit: {
        if (form.invalid) {

        } else {
          this.put(form);
        }
        break;
      }
      case FormMode.Del: {
        this.delete();
        break;
      }
      default: {
        break;
      }
    }
  }

  public post(form: any) {
    this.clients.create(this.model).subscribe(result => {
      form.resetForm();
      this.resetForm();
      this.loadListData();
      // this.alert.send(new AlertMessage("ClientInsertSuccess", "Saved sucessfully", AlertSeverity.Success, <AlertOptions>{ BoxType: AlertTypes.Toast }));
      this.openSnackBar('Client created sucessfully', 'success');
    }, error => function (ex) {
      // this.alert.send(AlertMessage.getOnHttpError("ClientInsertFail", "Failed to save", error));
      this.openSnackBar('Failed to create Client', 'error');
    });
  }

  public put(form: any) {
    this.clients.update(this.model).subscribe(result => {
      form.resetForm();
      this.resetForm();
      this.loadListData();
      //this.alert.send(new AlertMessage("ClientUpdateSuccess", "Saved sucessfully", AlertSeverity.Success, <AlertOptions>{ BoxType: AlertTypes.Toast }));
      this.openSnackBar('Client updated sucessfully', 'success');
    }, error => {
      //this.alert.send(AlertMessage.getOnHttpError("ClientUpdateFail", "Failed to update", error));
      this.openSnackBar('Failed to update Client', 'error');
    });
  }

  public delete() {
    this.clients.delete(this.model.id).subscribe(result => {
      this.resetForm();
      this.loadListData();
      this.alert.send(new AlertMessage("ClientDeleteSuccess", "Deleted sucessfully", AlertSeverity.Success, <AlertOptions>{ BoxType: AlertTypes.Toast }));
    }, error => {
      this.alert.send(AlertMessage.getOnHttpError("ClientDeleteFail", "Failed to delete", error));
    });
  }

  public loadListData() {
    this.clients.getAll(null).subscribe(result => {
      //this.formListData = new Array<Client>();
      // result.forEach(e => {
      //  //debugger;
      //   this.formListData.push(
      //     //Id: e.Id,
      //     //Name: e.Name,
      //     //BillingID: e.BillingID,
      //     //BillingContactID: e.BillingContactID,
      //     //BillingDay: new Date(e.BillingDay),
      //     //BillingFrequency: e.BillingFrequency,
      //     //LastBilled: new Date(e.LastBilled),
      //     ////CarrierId: e.CarrierId,
      //     ////Carrier: null,
      //     //selected: false,
      //     // Id: e.Id,
      //     // Name: e.Name,
      //     // BillingID: e.BillingID,
      //     // BillingContactID: e.BillingContactID,
      //     // BillingDay: (new Date(), e?.BillingDay),
      //     // BillingFrequency: e.BillingFrequency,
      //     // LastBilled: (new Date(), e?.LastBilled),
      //     // ClientCarrierRateFiles: e.ClientCarrierRateFiles,
      //     // selected: false,

      //     JSON.parse(e)
      //   );
      //   console.log('The FormList: '+this.formListData);
      // });

      //var out = JSON.parse(result)
      for (var i of result) {
        this.formListData.push(i);
      }
      this.dataSource = new MatTableDataSource(this.formListData);


      //console.log('The FormList: '+ JSON.parse(this.formListData[0]));

    }, error => {
      this.alert.send(AlertMessage.getOnHttpError("ClientGetListFail", "Failed to get client list", error));
    });
  }

  public resetForm() {
    this.mode = FormMode.None;
    this.model.selected = false;
    this.model = new Client();
  }

  public showFind() {
    this.mode = FormMode.Find;
    this.model.selected = false;
    this.model = new Client();
  }

  public showNew() {
    this.mode = FormMode.New;
    this.model.selected = false;
    this.model = new Client();
  }

  public showEdit(p: Client) {
    this.mode = FormMode.Edit;
    this.model.selected = false;
    this.model = p;
    this.model.selected = true;
  }

  public showDel(p: Client) {
    this.mode = FormMode.Del;
    this.model.selected = false;
    this.model = p;
    this.model.selected = true;
  }

  openSnackBar(message: string, messageType:'error'|'success'|'notification') {
    let config = new MatSnackBarConfig();
    config.data = {
      message: message,
      type:messageType
    };
    config.duration = environment.messageTimeOut;
    config.verticalPosition = 'top';
    config.horizontalPosition = 'center';
    config.panelClass =messageType;
    this._snackBar.openFromComponent(SnackbarComponent, config);
  }
}
